import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/amazon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M257.2 162.7C208.5 164.5 87.7 178.2 87.7 280.2 87.7 389.7 226 394.2 271.2 323.4 277.7 333.6 306.6 360.9 316.5 370.2L373.3 314.2S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3L167.5 143.1C183.8 93.6 221.7 93.6 221.7 93.6 262.4 93.5 257.2 123.4 257.2 162.7zM257.2 249.5C257.2 329.5 173 317.5 173 266.7 173 219.5 223.5 210 257.2 208.9V249.5zM393.2 413C385.5 423 323.2 480 218.7 480S34.2 408.5 9.7 379C2.9 371.3 10.7 367.7 15.2 370.7 88.5 415.2 203 488.5 387.7 401 395.2 397.3 401 403 393.2 413zM433 415.2C426.5 431 417 442 411.8 446.2 406.3 450.7 402.3 448.9 405.3 442.4S424.6 395.9 418 387.4C411.5 379.1 381 383.1 370 384.2 359.2 385.2 357 386.2 356 383.9 353.7 378.2 377.7 368.4 393.5 366.4 409.2 364.6 434.5 365.6 439.5 372.1 443.2 377.2 439.5 399.2 433 415.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/amazon.js
// module id = ygdl
// module chunks = 144